import { render, staticRenderFns } from "./PerformerList.vue?vue&type=template&id=49c2a02f&scoped=true"
import script from "./PerformerList.vue?vue&type=script&lang=js"
export * from "./PerformerList.vue?vue&type=script&lang=js"
import style0 from "./PerformerList.vue?vue&type=style&index=0&id=49c2a02f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2a02f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c2a02f')) {
      api.createRecord('49c2a02f', component.options)
    } else {
      api.reload('49c2a02f', component.options)
    }
    module.hot.accept("./PerformerList.vue?vue&type=template&id=49c2a02f&scoped=true", function () {
      api.rerender('49c2a02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/PerformerList.vue"
export default component.exports